import styles from "./Loader.module.css"

const Loader = ({ size = "medium", variant = "spinner", color = "primary", text, centered = false, ...props }) => {
  const loaderClasses = [styles.loader, styles[size], styles[variant], styles[color], centered && styles.centered]
    .filter(Boolean)
    .join(" ")

  const renderLoader = () => {
    switch (variant) {
      case "dots":
        return (
          <div className={styles.dots}>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
          </div>
        )
      case "pulse":
        return <div className={styles.pulse}></div>
      case "bars":
        return (
          <div className={styles.bars}>
            <div className={styles.bar}></div>
            <div className={styles.bar}></div>
            <div className={styles.bar}></div>
            <div className={styles.bar}></div>
          </div>
        )
      default:
        return <div className={styles.spinner}></div>
    }
  }

  return (
    <div className={loaderClasses} {...props}>
      {renderLoader()}
      {text && <div className={styles.text}>{text}</div>}
    </div>
  )
}

export default Loader
